import {
    battery,
    configured,
    controlledDevices,
    controlledDevicesLeft,
    controlledDevicesRight,
    firmware,
    lastSeen,
    lastUpdate,
    mfgId,
    name,
    reachable
} from '~/helpers/fields-description';
import { DevicesModule } from '~/store/modules/devices';
import { WirelessSwitch2Buttons } from './WirelessSwitch2Buttons.model';

export class NLD extends WirelessSwitch2Buttons {

    get isNewDataFormat() {
        return Number(DevicesModule.getGatewayOfModuleById(this.id)?.firmware) > 302;
    }

    get shouldShowDevice(): boolean {
        // if we are in the new data format (after firmware 302), we want to show the device entries that has "#" in their id
        // otherwise we want to show the device entry that does not have "#" in its id
        return this.isNewDataFormat ? this.deviceIdIncludesHash : !this.deviceIdIncludesHash;
    }
    get fieldLastSeen() {
        return lastSeen(this.mainDevice?.last_seen, this.mainDevice?.reachable ? '' : 'error--text');
    }
    get fieldConfigured() {
        return configured(this.configured);
    }
    get fieldMfgId() {
        return mfgId(typeof this.mfg_id !== 'undefined' ? this.mfg_id : undefined);
    }
    get fieldReachable() {
        return reachable(this.reachable);
    }
    get fieldBattery() {
        return battery(this.getBatteryIcon(this.mainDevice?.battery_vp), this.mainDevice?.battery_vp);
    }
    get fieldName() {
        return name(this.mainDevice?.name);
    }
    get fieldFirmware() {
        return firmware(this.mainDevice?.firmware);
    }
    get fieldLastUpdate() {
        return lastUpdate(this.mainDevice?.last_fw_update);
    }
    get fieldControlledDevices() {
        if (this.isNewDataFormat) {
            return controlledDevices(this.controlledDevice(0));
        }
    }
    get fieldControlledDevicesLeft() {
        if (!this.isNewDataFormat) {
            return controlledDevicesLeft(this.controlledDevice(0));
        }
    }
    get fieldControlledDevicesRight() {
        if (!this.isNewDataFormat) {
            return controlledDevicesRight(this.controlledDevice(1));
        }
    }

}
